@if ((modelsLoading$ | async) === 'loaded') {
  <h3-sampling-workspace-navbar
    [isSaving]="isSaving$ | async"
  ></h3-sampling-workspace-navbar>
  @if (isUsingGenAi$ | async) {
    <h3-gen-ai-container>
      <h3-sampling-workspace-header
        projection-location="header"
      ></h3-sampling-workspace-header>
      <h3-sampling-workspace-footer
        projection-location="footer"
      ></h3-sampling-workspace-footer>
    </h3-gen-ai-container>
  } @else if (isUsingCategorization$ | async) {
    <h3-categorization-container>
      <h3-sampling-workspace-header
        projection-location="header"
      ></h3-sampling-workspace-header>
      <h3-sampling-workspace-footer
        projection-location="footer"
      ></h3-sampling-workspace-footer>
    </h3-categorization-container>
  } @else {
    <h3-sampling-workspace-header></h3-sampling-workspace-header>
    <div class="row">
      <div class="page-wrap">
        <h3-root-h3ml-container></h3-root-h3ml-container>
      </div>
    </div>
    <h3-sampling-workspace-footer></h3-sampling-workspace-footer>
  }
}
